<div *ngIf="arquivo !== undefined">

  <div style="margin-bottom: 0.5em; text-align: right">
    <button pButton type="button" title="Baixar arquivo" (click)="download()" icon="pi pi-download"></button>
  </div>

  <div *ngIf="!temVisualizador" style="text-align: center; padding: 2em" class="audio">
    <i class="pi pi-exclamation-triangle" style="color: #f0ad4e; font-size: 2em"></i>
    <p>A visualização do tipo de arquivo: {{arquivo.tipo}} não é suportada!</p>
  </div>

  <div *ngIf="temVisualizador">

    <div *ngIf="arquivo.categoria === 'AUDIO'" class="audio">
      <audio controls [src]="base64">
      </audio>
    </div>

    <div *ngIf="arquivo.categoria === 'VIDEO'" class="video">
      <video controls style="width: 100%; height: 100%" [src]="base64">
      </video>
    </div>

    <div *ngIf="arquivo.categoria === 'IMAGEM'" class="imagem">
      <img [src]="base64" alt="Imagem selecionada">
    </div>

    <div *ngIf="arquivo.categoria === 'DOCUMENTO'">
      <div *ngIf="arquivo.tipo === 'TEXT_HTML' || arquivo.tipo === 'TEXT_PLAIN'" class="html">
        <div [innerHTML]="texto"></div>
      </div>

      <div *ngIf="arquivo.tipo === 'TEXT_RICHTEXT'">
        <div *ngFor="let html of resultadoHTML" [innerHTML]="html"></div>
      </div>

      <div *ngIf="arquivo.tipo === 'APPLICATION_PDF'" class="pdf">
        <iframe [src]="pdfUrl" style="width: 100%; height: 100%;" frameborder="0"></iframe>
      </div>
    </div>

    <div *ngIf="arquivo.categoria === 'GEOGRAFICO'" class="geografico">
      <div #gmapViewer [style]="{'width':'100%','height':'500px'}">
      </div>
    </div>
  </div>
</div>
